import 'trumbowyg';

export const editing = {
    init: function() {
        $('.options .edit').on('click', editing.editorToggle);
        editing.wysiwygInit();
    },
    editorToggle: function() {
        var self = $(this);
        var par = self.parents('.info');
        var options = par.find('.options');
        var elems = par.find('.saved, .editor-nest');
        elems.slideToggle(200);
        options.toggleClass('active');
    },
    wysiwygInit: function() {
        var editor = $('.editor');
        editor.each(function() {
            var self = $(this);
            var par = self.parents('.info')
            var saved = par.find('.saved').html();
            var reset = par.find('.reset-editor');
            self.trumbowyg({
                svgPath: 'dist/img/icons.svg',
                btns: [
                    ['viewHTML'],
                    ['unorderedList', 'strong', 'em', 'underline'],
                    ['insertImage'],
                    ['undo', 'redo']
                ]
            });

            reset.on('click', function() {
                self.trumbowyg('html', saved);
            });
        });
    }
}